import { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Skeleton } from "../components/ui/skeleton";
import { toast } from "sonner";
import { FileText, Download, Eye } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MONTH_NAMES = ["", "Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];

export default function PayslipsPage() {
  const { getAuthHeaders } = useAuth();
  const [payslips, setPayslips] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch_ = async () => { try { const r = await axios.get(`${API}/payslips`, { headers: getAuthHeaders() }); setPayslips(r.data); } catch { toast.error("Lohnabrechnungen konnten nicht geladen werden"); } finally { setLoading(false); } };
    fetch_();
  }, [getAuthHeaders]);

  const downloadPayslip = async (id, month, year) => {
    try { const r = await axios.get(`${API}/payslips/${id}/download`, { headers: getAuthHeaders(), responseType: "blob" }); const url = window.URL.createObjectURL(new Blob([r.data], { type: "application/pdf" })); const a = document.createElement("a"); a.href = url; a.setAttribute("download", `Lohnabrechnung_${MONTH_NAMES[month]}_${year}.pdf`); document.body.appendChild(a); a.click(); a.remove(); window.URL.revokeObjectURL(url); toast.success("PDF wird heruntergeladen"); } catch { toast.error("Fehler beim Herunterladen"); }
  };

  const viewPayslip = async (id) => {
    try { const r = await axios.get(`${API}/payslips/${id}/download`, { headers: getAuthHeaders(), responseType: "blob" }); window.open(window.URL.createObjectURL(new Blob([r.data], { type: "application/pdf" })), "_blank"); } catch { toast.error("Fehler beim Oeffnen"); }
  };

  if (loading) return <div className="space-y-4"><Skeleton className="h-8 w-48" />{[1,2,3].map(i => <Skeleton key={i} className="h-24" />)}</div>;

  return (
    <div className="space-y-6">
      <div><h1 className="font-heading font-bold text-3xl sm:text-4xl tracking-tight text-slate-900 uppercase">Lohnabrechnungen</h1><p className="mt-1 text-slate-500 font-body">Ihre monatlichen Abrechnungen im Ueberblick</p></div>
      <div className="space-y-3">
        {payslips.map((p, i) => (
          <Card key={p.id} className="border-slate-200 shadow-none hover:border-blue-500/50 animate-fade-in" style={{ animationDelay: `${i * 0.05}s` }}>
            <CardContent className="p-4 md:p-6"><div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-lg bg-slate-100 flex items-center justify-center flex-shrink-0"><FileText className="w-6 h-6 text-slate-600" /></div>
                <div><h3 className="font-heading font-semibold text-lg text-slate-900">{MONTH_NAMES[p.month]} {p.year}</h3>
                <div className="flex gap-4 mt-1 flex-wrap items-center">{p.has_file ? <span className="inline-flex items-center text-xs font-heading uppercase tracking-wide text-green-700 bg-green-50 border border-green-200 px-2 py-0.5 rounded">Original PDF</span> : p.gross_salary > 0 ? <><span className="text-sm text-slate-500">Brutto: {p.gross_salary?.toLocaleString("de-DE", { style: "currency", currency: "EUR" })}</span><span className="text-sm font-medium text-slate-900">Netto: {p.net_salary?.toLocaleString("de-DE", { style: "currency", currency: "EUR" })}</span></> : null}</div></div>
              </div>
              <div className="flex gap-2">
                <Button variant="ghost" size="sm" onClick={() => viewPayslip(p.id)} className="text-slate-500 hover:text-blue-600"><Eye className="w-4 h-4" /></Button>
                <Button variant="ghost" size="sm" onClick={() => downloadPayslip(p.id, p.month, p.year)} className="text-slate-500 hover:text-blue-600"><Download className="w-4 h-4" /></Button>
              </div>
            </div></CardContent>
          </Card>
        ))}
      </div>
      {payslips.length === 0 && <div className="text-center py-12"><FileText className="w-12 h-12 text-slate-300 mx-auto" /><p className="mt-3 text-slate-500">Keine Lohnabrechnungen vorhanden</p></div>}
    </div>
  );
}
